var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup224(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_224",
    "data-name": "Group 224",
    transform: "translate(-566.02 -128.019)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3730",
    "data-name": "Path 3730",
    d: "M573.524,128.019a7.5,7.5,0,1,1-7.5,7.441A7.5,7.5,0,0,1,573.524,128.019Zm1,8.5h2.445a1,1,0,1,0,.006-2h-2.451c0-.831,0-1.638,0-2.445a1,1,0,1,0-2-.007q0,1.141,0,2.281v.17h-2.445a1,1,0,1,0-.007,2h2.452c0,.831,0,1.638,0,2.445a1,1,0,1,0,2,.007q0-1.133,0-2.266Z",
    fill: "#fdc300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3731",
    "data-name": "Path 3731",
    d: "M667.488,229.487v.186q0,1.133,0,2.266a1,1,0,1,1-2-.007c0-.807,0-1.614,0-2.445h-2.452a1,1,0,1,1,.007-2h2.445v-.17q0-1.141,0-2.281a1,1,0,1,1,2,.007c0,.807,0,1.614,0,2.445h2.451a1,1,0,1,1-.006,2Z",
    transform: "translate(-92.968 -92.968)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup224);
export default __webpack_public_path__ + "static/media/Group 224.0bd50a65e60169061774b3ab9d77ec0b.svg";
export { ForwardRef as ReactComponent };